import axios from 'axios'
import router from '@/router'
import { useUserStore } from '@/store/user'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || '',
  timeout: 150000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    if (error.response) {
      const { status } = error.response
      switch (status) {
        case 401:
          useUserStore().clearUser()
          router.push('/login')
          break
        case 403:
          console.error('没有权限访问该资源')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error(`请求错误: ${status}`)
      }
    } else if (error.message.includes('timeout')) {
      console.error('请求超时，请稍后重试')
    } else {
      console.error('网络连接异常，请检查网络')
    }
    return Promise.reject(error)
  }
)

export default service
